import type { AdminHomeLink, FeatureRoute } from '@/shared/registry'

import { bulkImportPermission, importUsersPath, userImportRoute, userImportsPath } from './paths'

/** Import Users, Find Imports and an import's report (SM-16). */
export const userImportRoutes: readonly FeatureRoute[] = [
  {
    path: userImportsPath,
    titleId: 'siteManagement.userImports.find.title',
    page: () => import('./FindUserImportsPage').then((module) => module.FindUserImportsPage),
  },
  {
    path: importUsersPath,
    titleId: 'siteManagement.userImports.create.title',
    page: () => import('./ImportUsersPage').then((module) => module.ImportUsersPage),
  },
  {
    path: userImportRoute,
    titleId: 'siteManagement.userImports.details.title',
    page: () => import('./UserImportPage').then((module) => module.UserImportPage),
  },
]

/** Import Users and Find Imports on Admin Home, with the users. */
export const userImportAdminHomeLinks: readonly AdminHomeLink[] = [
  { id: 'import-users', category: 'users', labelId: 'siteManagement.userImports.create.title', path: importUsersPath, permission: bulkImportPermission },
  { id: 'find-user-imports', category: 'users', labelId: 'siteManagement.userImports.find.title', path: userImportsPath, permission: bulkImportPermission },
]
